export default class Collapse {
    constructor(element, animationSpeed = '400') {
        this.element = element;
        this.animationSpeed = animationSpeed;

        this.setStyles();
    }

    setStyles() {
        this.element.classList.add('clcollapse');

        this.element.style.transition = `max-height ${this.animationSpeed}ms ease-out`
    }

    toggle() {
        if (this.element.style.maxHeight) {
            this.element.style.maxHeight = null;
        } else {
            this.element.style.maxHeight = this.element.scrollHeight + "px";
        }
    }

    show() {
        this.element.style.maxHeight = this.element.scrollHeight + "px";
    }

    hide() {
        if (this.element.style.maxHeight) {
            this.element.style.maxHeight = null;
        }
    }
}
